// Each running timer gets a color so its inline duration chip and its panel row
// can be matched at a glance. `chip` styles the clickable in-text duration;
// `dot` is the solid swatch shown beside the timer in the panel. Full class
// strings are spelled out so Tailwind includes them in the build.
export interface TimerColor {
  chip: string
  dot: string
}

export const TIMER_COLORS: TimerColor[] = [
  {
    chip: "bg-sky-100 text-sky-800 hover:bg-sky-200 dark:bg-sky-900/50 dark:text-sky-300 dark:hover:bg-sky-900",
    dot: "bg-sky-500",
  },
  {
    chip: "bg-violet-100 text-violet-800 hover:bg-violet-200 dark:bg-violet-900/50 dark:text-violet-300 dark:hover:bg-violet-900",
    dot: "bg-violet-500",
  },
  {
    chip: "bg-emerald-100 text-emerald-800 hover:bg-emerald-200 dark:bg-emerald-900/50 dark:text-emerald-300 dark:hover:bg-emerald-900",
    dot: "bg-emerald-500",
  },
  {
    chip: "bg-rose-100 text-rose-800 hover:bg-rose-200 dark:bg-rose-900/50 dark:text-rose-300 dark:hover:bg-rose-900",
    dot: "bg-rose-500",
  },
  {
    chip: "bg-orange-100 text-orange-800 hover:bg-orange-200 dark:bg-orange-900/50 dark:text-orange-300 dark:hover:bg-orange-900",
    dot: "bg-orange-500",
  },
  {
    chip: "bg-cyan-100 text-cyan-800 hover:bg-cyan-200 dark:bg-cyan-900/50 dark:text-cyan-300 dark:hover:bg-cyan-900",
    dot: "bg-cyan-500",
  },
]

export function timerColor(colorIndex: number): TimerColor {
  return TIMER_COLORS[colorIndex % TIMER_COLORS.length]
}
